/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/split_medium'
export default icon
